import { contentTagsServices } from '../services/contentTagsServices';
import _ from 'lodash';
import { ContentTagAction } from '../types/ContentTagAction';
import ContentTagData from '../types/ContentTagData';

const contentTagsList = (contentType?:any) => (dispatch: any) => {
  const success = (data: ContentTagData[]): ContentTagAction =>
    ({ type: 'CONTENT_TAG_SUCCESS', data });
  const failure = (error: string): ContentTagAction =>
    ({ type: 'CONTENT_TAG_FAILED', error });

  contentTagsServices.list()
    .then(
      (res: any) => {
        if (!_.isEmpty(contentType)) {
          res = _.filter(res, (item:any) => _.includes(item.contentTypes, contentType));
        }
        
        dispatch(success(res));
      },
      err => { dispatch(failure(err)) }
    );
}

const contentTagsActions = {
  contentTagsList,
};

export default contentTagsActions;